document.addEventListener("DOMContentLoaded", function (){


// all slider
window.SplideSliderFunction = function () {
  document.querySelectorAll('.splide').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';

   
    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      interval: autoplayintervel || 3000,
      breakpoints: {
        989: {
          pagination: paginatione,
          drag: true,
          perPage: 3
        },
        767: {
          perPage: 2,
          arrows: arrows,
          pagination: paginatione,
        },
        480: {
          perPage: 1,
          arrows: arrows,
          pagination: paginatione
        }
      }
    });

   

const bar = splide.root.querySelector('.my-carousel-progress-bar');
if (bar){
splide.on("mounted move", function () {
  const totalPages = splide.Components.Controller.getEnd() + 1;
  const currentPage = splide.index + 1;
  const rate = (currentPage / totalPages) * 100;
  bar.style.width = rate + "%";
});
}


splide.mount();
    
    
  });
  
};

SplideSliderFunction();






// full faq

     document.querySelectorAll(".question").forEach(function (item){
        item.addEventListener("click", function (){
         this.parentElement.classList.toggle("active");

          // hide show div
         const nextdiv = this.nextElementSibling;
          if (window.getComputedStyle(nextdiv).display == "none"){
               nextdiv.style.display = "block";

          }else{
               nextdiv.style.display = "none";
          }


         // sibling process
         const topparent = this.parentElement.parentElement.children;
        
         for( let i=0; i < topparent.length; i++){  
          const siblingcount = topparent[i]; 
              console.log(siblingcount);
            if(siblingcount != this.parentElement){
               siblingcount.classList.remove("active");
               const dataText = siblingcount.querySelector(".answer");
                dataText.style.display = "none";
            }
         }           
        });

    });






 // Quantity box in card product

 window.QuantityBxo = function () {
  document.querySelectorAll('.quantity-wrap').forEach(function(qtyBox) {
    const input = qtyBox.querySelector('.qty-input');
    const plus = qtyBox.querySelector('.plus');
    const minus = qtyBox.querySelector('.minus');

    plus.addEventListener('click', function() {
      let value = parseInt(input.value) || 1;
      input.value = value + 1;
      input.dispatchEvent(new Event('change'));
    });

    minus.addEventListener('click', function() {
      let value = parseInt(input.value) || 1;
      if (value > 1) input.value = value - 1;
      input.dispatchEvent(new Event('change'));
    });
  });

 }

 QuantityBxo();






window.initVariantHandler = function () {

  // ✅ Handle variant selection
  document.querySelectorAll('.option-select').forEach(select => {
    select.addEventListener('change', function () {
      const wrapper = this.closest('.var-functional-wrapper');
      const addBtn = wrapper.querySelector('.addCartBtn');

      let variantTitle = '';
      wrapper.querySelectorAll('.option-select').forEach(sel => {
        if (sel.value) {
          variantTitle += variantTitle === '' ? sel.value.trim() : ' / ' + sel.value.trim();
        }
      });

      const variantInput = wrapper.querySelector(
        `.variants-input-hidden[data-title="${variantTitle}"]`
      );

      if (variantInput) {
        const variantId = variantInput.dataset.id;
        const isAvailable = variantInput.dataset.ava === "true";
        const stockQty = parseInt(variantInput.dataset.qty, 10);

        addBtn.setAttribute("data-variant-id", variantId);

        // ✅ Handle untracked inventory (qty=0 but available=true)
        if (!isAvailable) {
          addBtn.textContent = "Out of Stock";
          addBtn.classList.add("out-of-stock");
          addBtn.setAttribute("disabled", true);
        } else {
          addBtn.textContent = "Add";
          addBtn.classList.remove("out-of-stock", "options-required");
          addBtn.removeAttribute("disabled");
        }
      } else {
        // ⚠️ No variant match
        addBtn.removeAttribute("data-variant-id");
        addBtn.textContent = "Option required";
        addBtn.classList.add("options-required");
      }
    });
  });


  // ✅ Add to Cart logic
  document.querySelectorAll('.var-functional-wrapper').forEach(function (wrapper) {
    const addBtn = wrapper.querySelector('.addCartBtn');
    const qtyInput = wrapper.querySelector('.qty-input');
    if (!addBtn) return;

    // ✅ Handle single-variant (no options) product
    const variantId = addBtn.getAttribute('data-variant-id');
    if (variantId) {
      const variantData = wrapper.querySelector(`.variants-input-hidden[data-id="${variantId}"]`);
      const isAvailable = variantData?.getAttribute('data-ava') === "true";

      if (!isAvailable) {
        disableOutOfStock(addBtn);
      } else {
        addBtn.classList.remove("options-required");
        addBtn.removeAttribute("disabled");
      }
    }

    addBtn.addEventListener('click', function () {
      const variantId = addBtn.getAttribute("data-variant-id");
      const options = wrapper.querySelectorAll(".option-select");

      // ✅ Require selection if product has variants
      if (options.length > 0) {
        let allSelected = true;
        options.forEach(opt => {
          if (!opt.value) allSelected = false;
        });

        if (!allSelected || !variantId) {
          return showSelectMessage(addBtn);
        }
      }

      // ✅ Prevent adding unavailable variants
      if (addBtn.classList.contains('out-of-stock')) return;

      const quantity = parseInt(qtyInput?.value) || 1;

      const items = [{ id: variantId, quantity }];
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer
        ? Array.from(cartDrawer.getSectionsToRender()).map(s => s.id)
        : [];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname
        })
      })
        .then(r => r.json())
        .then(data => {
          if (cartDrawer) {
            cartDrawer.renderContents(data);
            cartDrawer.classList.remove('is-empty');
            setTimeout(() => cartDrawer.open(), 750);
          }
          addBtn.textContent = "Added ✓";
          setTimeout(() => addBtn.textContent = "Add", 1500);
        })
        .catch(error => console.error("Add to cart error:", error));
    });
  });


  // ✅ Shared: Show "Select Options" message
  function showSelectMessage(btn) {
    btn.textContent = "Option required";
    btn.classList.add("warning");
    setTimeout(() => {
      btn.textContent = "Add";
      btn.classList.remove("warning", "options-required");
    }, 1500);
  }

  // ✅ Shared: Disable out-of-stock button
  function disableOutOfStock(btn) {
    btn.textContent = "Out of Stock";
    btn.classList.add("out-of-stock");
    btn.setAttribute("disabled", true);
  }
};

initVariantHandler();




// Quantity cart wrapper
const quantity = document.querySelector('.product-form__quantity');
    const buyBtn = document.querySelector('.buy-btn-wrap');

    if (quantity && buyBtn) {
        const wrapper = document.createElement('div');
        wrapper.className = 'quantity-cart-wrapper';

        quantity.parentNode.insertBefore(wrapper, quantity);

        // Move elements inside the wrapper
        wrapper.appendChild(quantity);
        wrapper.appendChild(buyBtn);
    }





window.addEventListener("globoFilterRenderCompleted", function() {
  QuantityBxo();
  initVariantHandler();
   });










// End
  });


  


